import { useCallback } from "react";
import { ContentCard } from "cerulean";
import { entities } from "byzantine";
import { useLocalization } from "@fluent/react";
import styles from "./CancelSubscriptionCard.module.scss";

interface CancelSubscriptionCardProps {
  subscriptionId?: string;
  openCancelSubscriptionDialog: (subscriptionId?: string) => void;
}

const CancelSubscriptionCard = ({
  subscriptionId,
  openCancelSubscriptionDialog,
}: CancelSubscriptionCardProps) => {
  const { l10n } = useLocalization();
  const subscription =
    entities.subscriptionMetadata.useSubscriptionById(subscriptionId ?? "") ??
    null;

  const handleCancel = useCallback(() => {
    openCancelSubscriptionDialog(subscriptionId);
  }, [subscriptionId, openCancelSubscriptionDialog]);

  if (!subscription) {
    return null;
  }

  const savings = subscription.estimated_savings ?? "";
  const merchantName = subscription.merchant_name ?? "";
  const header = l10n.getString(
    "cancel-subscription-card-header",
    null,
    "Cancel subscription"
  );
  const body =
    savings && subscription?.next_payment_date
      ? l10n.getString(
          "cancel-subscription-card-body",
          { savings, merchantName },
          `You could save $${savings} per year if you cancel your ${merchantName} subscription.`
        )
      : l10n.getString(
          "cancel-subscription-card-no-savings-body",
          { merchantName },
          `You could save some money if you cancel your ${merchantName} subscription.`
        );

  return (
    <ContentCard kind="button" onClick={handleCancel}>
      <div className={styles.container}>
        <div>
          <div className={styles.header}>{header}</div>
          <div className={styles.body}>{body}</div>
        </div>
        <div className={styles.chevronContainer}>
          <span className="narmi-icon-chevron-right" />
        </div>
      </div>
    </ContentCard>
  );
};

export default CancelSubscriptionCard;
